const qs = require('qs')
const moment = require('moment')
const { api } = require('../api')

async function getTypes(token) {
  const options = {
    method: 'GET',
    url: '/admin/dashboard/visitTypes',
    headers: {
      Authorization: `${token}`,
    },
  }

  const resp = await api(options)
  return resp.data
}

async function getHost(token) {
  const options = {
    method: 'GET',
    url: '/admin/dashboard/hostsBySearchText',
    params: { searchText: '', '': '' },
    headers: {
      Authorization: `${token}`,
    },
  }

  const resp = await api(options)
  return resp.data
}

async function getClient(token) {
  const options = {
    method: 'GET',
    url: '/admin/dashboard/realEstatesBySearchText',
    params: { searchText: '' },
    headers: {
      Authorization: `${token}`,
    },
  }

  const resp = await api(options)
  return resp.data
}

async function getStatus() {
  const response = []
  response.push(
    { id: 'OPEN', name: 'Aguardando Host' },
    { id: 'SCHEDULED', name: 'Agendado' },
    { id: 'DONE', name: 'Realizado' },
    { id: 'CANCELED', name: 'Cancelado' }
  )
  return response
}

async function getCity(token) {
  const options = {
    method: 'GET',
    url: '/admin/dashboard/citiesBySearchText',
    params: {},
    headers: {
      Authorization: `${token}`,
    },
  }

  const res = await api(options)
  return res.data
}

async function getAppointmentId(token, idAppointment) {
  const options = {
    method: 'GET',
    url: `/admin/dashboard/appointmentDetails/${idAppointment}`,
    headers: {
      Authorization: `${token}`,
    },
  }

  const resp = await api(options)
  return await resp.data
}

async function getAppointments(
  token,
  status,
  Types,
  Citys,
  hosts,
  client,
  startDate,
  endDate,
  startTime,
  endTime,
  page,
  findHostMode,
  country,
  category,
  search,
  clients,
  branches,
  confirmed,
  confirmationEmailSent
) {
  const endPointFetchType = category === 'GROUP' ? 'listAppointmentGroups' : 'filterAppointments'

  const options = {
    method: 'GET',
    url: `/admin/dashboard/${endPointFetchType}`,
    params: {
      search: search,
      status: status,
      hostsIds: hosts,
      visitTypes: Types,
      clientsIds: client ?? clients,
      citiesIds: Citys,
      startDate: startDate,
      endDate: endDate,
      startTime: startTime,
      endTime: endTime,
      size: '9999',
      page: page,
      showAllDetails: 'false',
      findHostMode: findHostMode,
      branchesIds: branches,
      confirmed: confirmed,
      confirmationEmailSent: confirmationEmailSent,
      country: country
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
    headers: { Authorization: `${token}` },
  }

  const { data } = await api(options)
  return await data
}

async function getAppointmentsReload(token, page, findHostMode) {
  const options = {
    method: 'GET',
    url: '/admin/dashboard/filterAppointments',
    params: {
      lastUpdated: `${moment
        .utc(Date.now())
        .subtract(15, 'minutes')
        .format()}`,
      size: '9999',
      page: page,
      showAllDetails: 'true',
      findHostMode: findHostMode,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params)
    },
    headers: { Authorization: `${token}` },
  }

  const resp = await api(options)
  return await resp.data
}

async function getAlert(token) {
  const options = {
    method: 'GET',
    url: '/admin/dashboard/operationAlerts',
    params: { page: '0', size: '100' },
    headers: { Authorization: `${token}` },
  }

  const resp = await api(options)
  return await resp.data
}

async function closeAlert(token, idAlert, solution) {
  const options = {
    method: 'POST',
    url: `/admin/dashboard/operationAlerts/${idAlert}`,
    headers: {
      Authorization: `${token}`,
    },
    data: { resolver_comment: `${solution}` },
  }

  const resp = await api(options)
  return await resp.data
}

exports.getCity = getCity
exports.getTypes = getTypes
exports.getHost = getHost
exports.getStatus = getStatus
exports.getClient = getClient
exports.getAppointmentId = getAppointmentId
exports.getAppointments = getAppointments
exports.getAppointmentsReload = getAppointmentsReload
exports.getAlert = getAlert
exports.closeAlert = closeAlert
